import { DanmakuParser } from "./Danmaku/DanmakuParser";
import { Timeline } from "./Timeline/Timeline";
import { TimelineDriver } from "./Timeline/TimelineDriver";
import { Stage } from "./Stage/Stage";
/**
 * 控制器, 控制高级弹幕的处理与渲染流程
 * */
var Controller = /** @class */ (function () {
    function Controller(_a) {
        var stageSize = _a.stageSize, container = _a.container;
        var _this = this;
        /** 播放时时长, 暂停时为当前时长, 播放时为开始播放时的时长 */
        this.playTime = 0;
        /** 起始时间戳(播放时时间戳 - 播放时时长), 用于计算播放时间, 暂停时为0 */
        this.startStamp = 0;
        /** 暂停状态 */
        this.isPaused = true;
        this.danmakuParser = new DanmakuParser();
        this.timeline = new Timeline();
        this.timelineDriver = new TimelineDriver({
            timeline: this.timeline,
            getTime: function () {
                return _this.getTime();
            },
            onCurrentDanmaku: function (list) {
                // 检测到即将产生弹幕时, 扔进舞台模块
                _this.stage.addFromList(list || []);
            },
        });
        this.container = container;
        this.stage = new Stage({
            container: this.container,
            size: stageSize,
            getTime: function () {
                return _this.getTime();
            },
        });
    }
    /** 获取当前时间 */
    Controller.prototype.getTime = function () {
        if (this.isPaused) {
            return this.playTime; // 暂停时获取时间
        }
        else {
            return Date.now() - this.startStamp; // 播放时获取时间
        }
    };
    /** 加载弹幕 */
    Controller.prototype.loadDanmaku = function (dList) {
        var _this = this;
        dList.forEach(function (d) {
            _this.addDanmaku(d);
        });
    };
    /** 根据播放器弹幕格式添加弹幕 */
    Controller.prototype.addDanmaku = function (d) {
        var dan = this.danmakuParser.parse(d);
        dan && this.timeline.add(dan);
    };
    /** 根据播放器弹幕格式直接播放一条预览弹幕 */
    Controller.prototype.playDanmaku = function (d) {
        var dan = this.danmakuParser.parse(d);
        dan && this.stage.add(dan); // 不需要放进时间轴, 直接以播放形式放进舞台
    };
    /** 根据id删除弹幕 */
    // public removeDanmaku() {}
    /** 播放 */
    Controller.prototype.play = function () {
        if (this.isPaused) {
            this.isPaused = false;
            this.startStamp = Date.now() - this.playTime;
            this.stage.play(); // 舞台设为播放状态
            this.timelineDriver.play(); // 时间轴播放
        }
    };
    /** 暂停 */
    Controller.prototype.pause = function () {
        if (!this.isPaused) {
            this.isPaused = true;
            this.playTime = Date.now() - this.startStamp; // 设定当前时间
            this.startStamp = 0;
            this.stage.pause(); // 舞台设为暂停状态
            this.timelineDriver.pause(); // 时间轴暂停
        }
    };
    /** 跳转 */
    Controller.prototype.seek = function (time) {
        this.playTime = time; // 设定当前时间
        if (!this.isPaused) {
            this.startStamp = Date.now() - this.playTime; // 重新获取起始时间戳
        }
        this.refresh(); // 刷新弹幕
    };
    /** 刷新 */
    Controller.prototype.refresh = function () {
        var list = this.timelineDriver.seek(); // 时间轴跳转, 重新获取弹幕内容
        this.stage.clear(); // 清空舞台
        this.stage.addFromList(list); // 将重新获取的弹幕内容添加到舞台
    };
    /** 清空弹幕 */
    Controller.prototype.clearDanmaku = function () {
        this.timeline.clear(); // 清空时间轴
        this.stage.clear(); // 清空舞台
    };
    /** 重置 */
    Controller.prototype.reset = function () {
        this.pause(); // 暂停
        this.timeline.clear(); // 清空时间轴
        this.seek(0); // 跳转至原点(同时清空舞台并复位时间轴)
    };
    return Controller;
}());
export { Controller };
//# sourceMappingURL=Controller.js.map